// React
import * as React from 'react';

// Router
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

// Route Components
import NotFound from 'containers/NotFound';
import AccountActivationContainer from 'containers/AccountActivation/index';

export default (props) => (
    <Switch>
        <Route exact path="/account-activation-request/" component={ AccountActivationContainer } />
        <Route exact path="/account-activation-request/:code" component={ AccountActivationContainer } />
        {/* {
            setTimeout(() => <Route path="*" component={NotFound}/>, 1000)
        } */}
    </Switch>
)


// WEBPACK FOOTER //
// ./src/js/routes/AccountActivationRoutes.js